"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiteralTokens = {
    BooleanLiteral: 'BooleanLiteral',
    StringLiteral: 'StringLiteral',
    NumberLiteral: 'NumberLiteral',
    DebugLiteral: 'DebugLiteral',
    NumberLiteralRange: 'NumberLiteralRange',
    ArrayLiteral: 'ArrayLiteral',
};
exports.BooleanLiteralTokens = {
    true: 'true',
    false: 'false',
};
